const init = () => {};
document.querySelectorAll('.fullscreen-menu .nav-link').forEach((link) => {
	link.addEventListener('click', () => {
		const navbar = document.getElementById('mainNavbar');
		const bsCollapse = bootstrap.Collapse.getInstance(navbar);
		if (bsCollapse) bsCollapse.hide();
	});
});
window.addEventListener('scroll', function () {
	const nav = document.getElementById('main-nav');
	nav.classList.toggle('scrolled', window.scrollY > 50);
});
// Exports
export { init };
